<aside class="banking-certification">

  <!-- View Read Mode -->
  <form [formGroup]="bayportInfoForm" class="form" *ngIf="!isUpdate"  @growVertical>
    <div class="row row-spacing">
      <div class="col-md-3">
        <div class="labelL">Banco</div>
      </div>
      <div class="col-md-3 datoB  ">
        {{ initialData.banco }}
      </div>
      <div class="col-md-3">
        <div class="labelL">Tipo de cuenta</div>
      </div>
      <div class="col-md-3 datoB  ">
        {{ initialData.tipoCuenta }}
      </div>
    </div>
    <div class="row row-spacing">
      <div class="col-md-3">
        <div class="labelL ">
          Número de cuenta
        </div>
      </div>
      <div class="col-md-3 datoB  ">
        {{ initialData.numeroCuenta }}
      </div>
    </div>

    <div class="d-flex justify-content-center" style="margin-top: 2rem">
      <button-look-feel color="secondary" (clicked)="actualizarInformacionBancaria()">Editar</button-look-feel>
    </div>
  </form>
  <!-- End of View Edit Mode -->


  <!-- View Edit Mode -->
  <form [formGroup]="formInfoBancaria" class="form" *ngIf="isUpdate" @growVertical>
    <div class="row">
      <div class="col-md-6 form-field ">
        <div class="form-label">
          Banco</div>
        <input class="form-control" [style]="{ width: '100%', 'font-size': '14px' }" formControlName="banco" />

      </div>
      <div class="col-md-6 form-field ">
        <div class="form-label">
          Tipo de cuenta
        </div>
        <input class="form-control" [style]="{ width: '100%', 'font-size': '14px' }" formControlName="tipoCuenta" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-6 form-field ">
        <div class="form-label">
          Número de cuenta
        </div>
        <input class="form-control" [style]="{ width: '100%', 'font-size': '14px' }" formControlName="numeroCuenta" />
      </div>
    </div>
    <div class="d-flex flex-column align-items-center">
      <div class="d-none d-md-block mb-0 text-center text-white" *ngFor="let rule of rules">
        <img src="assets/icons/check-blue.svg" alt="" />
        <span [innerHTML]="rule"></span>
      </div>
      <app-card-file-upload class="mt-3" [titulo]="'Certificación bancaria'" [file]="documento" [rules]="rules">
      </app-card-file-upload>
    </div>
    <!-- Alerta -->
    <br>
    <div class="d-flex justify-content-center" *ngIf="showAdvertencia"  @growVertical>
      <app-advertencias [color]="colorAdvertencia">{{textoAdvertencia}}</app-advertencias>
    </div>
    <!-- Button -->
    <div class="d-flex justify-content-center" style="margin-top: 2rem">
      <button-look-feel color="secondary" (clicked)="upload()" [loading]="loadingAdvertencia"
        [disabled]="showAdvertencia">Guardar</button-look-feel>
    </div>
  </form>
</aside>